<div class="list-filters-content">
  <app-autocomplete
    label="BehaviorCode"
    placeholder="BehaviorCode"
    (selectionChange)="handleBehaviorCodeSelection($event)"
    [options]="behaviorCodeOptions"
    class="input"
  />
  <app-autocomplete
    label="User"
    placeholder="User"
    (selectionChange)="handleUserSelection($event)"
    [options]="userOptions"
    class="input"
  />
  <mat-form-field class="input">
    <mat-label>Start Date</mat-label>
    <input
      matInput
      [matDatepicker]="startDatePicker"
      type="text"
      [value]="startDate"
      (dateChange)="onStartDateUpdated($event)" />
    <mat-datepicker-toggle
      matSuffix
      [for]="startDatePicker"></mat-datepicker-toggle>
    <mat-datepicker #startDatePicker></mat-datepicker>
  </mat-form-field>
  <mat-form-field class="input">
    <mat-label>End Date</mat-label>
    <input
      matInput
      [matDatepicker]="endDatePicker"
      type="text"
      (dateChange)="onEndDateUpdated($event)" />
    <mat-datepicker-toggle
      matSuffix
      [for]="endDatePicker"></mat-datepicker-toggle>
    <mat-datepicker #endDatePicker></mat-datepicker>
  </mat-form-field>

  <mat-slide-toggle
    [color]="'primary'"
    class="filter-item"
    [formControl]="showDeactivatedRecordsControl">
    Show Deactivated Records
  </mat-slide-toggle>
</div>
